import React from 'react';
import footerRoutes from 'components/footer/footer.routes';
import FooterFixed from 'components/footer/footer-fixed';
import FooterFixedList from 'components/footer/footer-fixed-list';
import GoToTopCta from './go-to-top-cta';
import useMediaQuery from 'lib/use-media-query';

type PageFooterPropsType = {
    color?: string;
    goToTopHandler?: () => void;
    showGoToButton?: boolean;
};

const PageFooter = ({ color, goToTopHandler, showGoToButton }: PageFooterPropsType) => {
    const isBreakpointMobileDevice = useMediaQuery(1140);
    return (
        <FooterFixed>
            {showGoToButton ? (
                <div
                    style={{
                        position: isBreakpointMobileDevice ? 'relative' : 'fixed',
                        bottom: isBreakpointMobileDevice ? undefined : '56px',
                        right: isBreakpointMobileDevice ? undefined : '40px',
                        color: color || '#fff',
                        marginBottom: isBreakpointMobileDevice ? '24px' : undefined,
                    }}
                >
                    <GoToTopCta onClick={goToTopHandler} />
                </div>
            ) : null}
            <FooterFixedList list={footerRoutes} color={color} />
        </FooterFixed>
    );
};

export default PageFooter;
